import { QuoteLineItem } from './types';

/**
 * Calculates quote totals consistently across the application
 * This ensures admin and customer views show the same values
 */
export interface QuoteCalculation {
  subtotal: number;
  taxAmount: number;
  totalAmount: number;
}

export function calculateQuoteTotals(
  lineItems: QuoteLineItem[],
  taxRate: number,
  discountAmount: number = 0
): QuoteCalculation {
  // Calculate subtotal from line items
  const subtotal = lineItems.reduce((sum, item) => sum + (item.amount || 0), 0);
  
  // Calculate tax amount
  const taxAmount = subtotal * (taxRate / 100);
  
  // Calculate total amount
  const totalAmount = subtotal + taxAmount - discountAmount;
  
  return {
    subtotal,
    taxAmount,
    totalAmount
  };
}